<template>
  <div
    id="app"
    :class="{ 'menu_opened': foldIsShow , 'root_simple': isSimple, 'root_detail': isDetail, 'root_trad': isTrad, 'root_ees': isEes}"
  >
    <!-- ローディングスピンをモーダルで表示 -->
    <modal-loading-spin v-if="spinIsShow" />
    <!-- 保存ダイアログを表示 -->
    <modal-save
      v-if="modalSaveShow"
      @save="save"
      @modal-save-hide="hideSave"
    />
    <!-- 読込ダイアログを表示 -->
    <modal-load
      v-if="modalLoadShow"
      @load="loadFile"
      @modal-load-hide="hideLoad"
    />
    <!-- エラーメッセージを表示 -->
    <modal-error
      v-if="modalErrorShow"
      @modal-error-hide="hideError"
    />
    <!-- 計算以外の処理のローディングスピンをモーダルで表示 -->
    <modal-loading-short v-if="shortSpinIsShow" />
    <!-- 機器検索画面を表示 -->
    <modal-search-result v-if="searchResultIsShow" />
    <!-- 機器検索画面を表示 -->
    <modal-simple-to-detail v-if="simpleToDetailIsShow" />

    <!-- ヘッダーナビを表示 -->
    <layout-header 
      @show-save="showSave"
      @modal-save-hide="hideSave"
      @show-load="showLoad"
      @modal-load-hide="hideLoad"
      @toggle-menu="toggleMenu"
      :fold-is-show="foldIsShow"
    />

    <router-view />
    <help
        v-if="showHelp"
        @click="helpHide"
        :title="helpTitle"
        :text="helpText"
        :ref-title="referenceTitle"
        :ref-text="referenceText"
    />
    <div id="invisible"></div>
  </div>
</template>


<script>
/**
 * 基本になるVue
 * 
 * [算出プロパティ]
 * spinIsShow ... 計算用ローディングスピンの表示切替
 * shortSpinIsShow ... 計算以外の処理のローディングスピンの表示切り替え
 * searchResultIsShow ... 検索結果の表示切り替え
 * simpleToDetailIsShow ... 簡易から詳細に遷移する際のモーダル表示切替
 * isSimple ... 簡易版であるかどうかの判定
 * isDetail ... 詳細版であるかどうかの判定
 * 
 * [イベント処理]
 * 保存イベント検知時 ... XMLデータを保存し、保存用モーダル非表示イベントを発生させる
 * 保存用モーダル呼び出し検知時 ... 保存用モーダルを開く
 * 保存用モーダル非表示イベント検知時 ... 保存用モーダルを閉じる
 * 読み込みイベント検知時 ... XMLデータを読み込み、読み込み用モーダル非表示イベントを発生させる
 * 読み込み用モーダル呼び出し検知時 ... 読み込み用モーダルを開く
 * 読み込み用モーダル非表示イベント検知時 ... 読み込み用モーダルを閉じる
 * ハンバーガーメニューの表示切替イベント検知時 ... ハンバーガーメニューの表示/非表示を切り替える
 * エラーモーダル非表示イベント検知時 ... エラーを非表示にする
 * 
 * [データ]
 * modalSpinShow ... 計算中モーダルの表示
 * modalSaveShow ... 保存用モーダルの表示
 * modalLoadShow ... 読み込み用モーダルの表示
 * foldIsShow ...ハンバーガーメニューの表示
 * modalErrorShow ... エラーモーダルの表示
 */
import xml from '@/mixins/xml'
import help from '@/mixins/help'
import { mapGetters } from 'vuex'

export default {
    name:"App",
    data(){
        return {
          /**
           * 計算中モーダルの表示
           */
          modalSpinShow: false,
          /**
           * 保存用モーダルの表示
           */
          modalSaveShow: false,
          /**
           * 読み込み用モーダルの表示
           */
          modalLoadShow: false,
          /**
           * ハンバーガーメニューの表示
           */
          foldIsShow: false,
          /**
           * エラーモーダルの表示
           */
          modalErrorShow: false
        }
    },
    mixins:[xml, help],
    methods: {
      /**
       * XMLデータを保存し、保存用モーダル非表示イベントを発生させる
       */
      save(){
        this.xmlsave(this.data)
        this.hideSave()
      },
      /**
       * 保存用モーダルを開く
       */
      showSave(){
        this.modalSaveShow = true
      },
      /**
       * 保存用モーダルを閉じる
       */
      hideSave(){
        this.modalSaveShow = false
      },
      /**
       * XMLデータを読み込み、読み込み用モーダル非表示イベントを発生させる
       */
      loadFile(file){
        this.hideLoad()
        this.xmlload(file)
      },
      /**
       * 読み込み用モーダルを開く
       */
      showLoad(){
        this.modalLoadShow = true
      },
      /**
       * 読み込み用モーダルを閉じる
       */
      hideLoad(){
        this.modalLoadShow = false
      },
      /**
       * ハンバーガーメニューの表示/非表示を切り替える
       */
      toggleMenu(){
        this.foldIsShow = !this.foldIsShow
      },
      /**
       * エラーを非表示にする
       */
      hideError(){
        this.modalErrorShow = false
      },
    },
    computed: {
      ...mapGetters({
          data:'data/getData',
          view:'view/getData'
      }),
      /**
       * ローディングスピンの表示切り替え
       */
      spinIsShow(){
        return this.view.loadingSpinState
      },
      /**
       * 計算以外の処理のローディングスピンの表示切り替え
       */
      shortSpinIsShow(){
        return this.view.shortLoadingSpinState
      },
      /**
       * 検索結果の表示切り替え
       */
      searchResultIsShow(){
        return this.view.searchResultState
      },
      /**
       * 簡易から詳細に遷移する際のモーダル表示切替
       */
      simpleToDetailIsShow(){
        return this.view.simpleToDetailIsShow
      },
      /**
       * 簡易版であるかどうかの判定
       */
      isSimple(){
        if(this.$route.name !== null){
          return (this.$route.name.indexOf('simple') >= 0)
        } else {
          return false
        }
      },
      /**
       * 詳細版であるかどうかの判定
       */
      isDetail(){
        if(this.$route.name !== null){
          return (this.$route.name.indexOf('detail') >= 0)
        } else {
          return false
        }
      },
      /**
       * 気候風土適応住宅版であるかどうかの判定
       */
      isTrad(){
        if(this.$route.name !== null){
          return (this.$route.name.indexOf('trad') >= 0)
        } else {
          return false
        }
      },
      /**
       * 特定建築主基準版であるかどうかの判定
       */
      isEes(){
        if(this.$route.name !== null){
          return (this.$route.name.indexOf('ees') >= 0)
        } else {
          return false
        }
      },
    }
}
</script>

<style lang="scss">

$color_main: #41B8D4; //住宅版メインカラー：中間トーン
$color_main_dark: #1c4373; //住宅版メインカラー：ダークトーン
$color_main_light: #DDF8FF; //住宅版メインカラー：ライトトーン
$graduation_color_1: #6DC7DD; //住宅版グラデーションの中間色
$accent_color_main: #0443A8;//住宅版アクセントメインカラー
$accent_color_sub: #41B8B6;//住宅版アクセントサブカラー

$trad_color_main: #439b8c; //気候風土版メインカラー：中間トーン
$trad_color_main_dark: #065554; //気候風土版メインカラー：ダークトーン
$trad_color_main_light: #e6f8f4 ; //気候風土版メインカラー：ライトトーン
$trad_graduation_color_1: #8fd8c8; //気候風土版グラデーションの中間色
$trad_accent_color_main: #1c6368;//気候風土版アクセントメインカラー
$trad_accent_color_sub: #41B8D4;//気候風土版アクセントサブカラー

$ees_color_main: #56cabb; //特定建築主版メインカラー：中間トーン
$ees_color_main_dark: #116268; //特定建築主版メインカラー：ダークトーン
$ees_color_main_light: #eeffff ; //特定建築主版メインカラー：ライトトーン
$ees_graduation_color_1: #C2E6DA; //特定建築主版グラデーションの中間色
$ees_accent_color_main: #00767e;//特定建築主版アクセントメインカラー
$ees_accent_color_sub: #41B8D4;//特定建築主版アクセントサブカラー

body{
  margin: 0;
}
#app {
  display: block;
  font-family: "游ゴシック", YuGothic, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  min-width: 890px;
  min-height: 100vh;
  padding-top: 80px;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  color: #182430;
  background: linear-gradient(180deg, $color_main 0vh, $color_main 220px, $color_main_light 220px, $graduation_color_1 300vh);
  background-size: 105%;
  background-position: -10px 0;
  background-repeat: no-repeat;
  overflow-x: hidden;
}
/* ボタンなどの青枠を消す */
input[type="button"],
textarea,
select,
button {
  outline: none;
}
/* iOSでのデフォルトスタイルをリセット */
input[type="submit"],
input[type="button"] {
  border-radius: 0;
  -webkit-box-sizing: content-box;
  -webkit-appearance: button;
  appearance: button;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
}
input[type="submit"]::-webkit-search-decoration,
input[type="button"]::-webkit-search-decoration {
  display: none;
}
input[type="submit"]::focus,
input[type="button"]::focus {
  outline-offset: -2px;
}
.wrapper{
  display: block;
  width: calc(100% - 100px);
  box-sizing: border-box;
  margin: 0 auto 50px;
  padding: 35px 8px 35px 8px;
  background-color: white;
  border-radius: 7px;
  overflow-x: hidden;
  z-index: 10;
}
.wrapper>.section_wrap:first-child{
  padding-top: 60px;
}
/* 書体が反映されていないものをフォロー */
button, input, select, textarea {
font-family : inherit;
font-size : 100%;
}
button,
input[type="button"]{
  cursor: pointer;
  outline:0;
}
/* link */
a:link { 
	color: #111;
	text-decoration:none;
}
a:visited { color: #333; }
a:hover { 
  color: #666;
  font-size: bolder;
}
a:active { color: #555; }
a.alink_disabled{
  pointer-events: none;
  color: #ccc;
}

/* 文字関係 */
h2{
  margin: 10px 20px;
}
.msg_center{
  display: block;
  width: 70%;
  max-width: 900px;
  text-align: center;
  margin: 0 auto 10px;
}

/*
レイアウト関係 
*/

/* 子要素をセンター揃えで並べる */
.flex_center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_center.column{
  flex-direction: column;
}
.flex_left{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex_wrap{
  display: flex;
  flex-wrap: wrap;
}
/* 自要素をセンター揃えにする */
.align_center{
  margin: 0 auto;
}

/* 自要素を右揃えにする */
.align_right{
  margin: 0 0 0 auto;
}
td>input[type="button"][data-v-1ef0aead] {
    margin: auto 3px;
}

/* ラジオボタンのグループ */
.boxinbox{
    display: -ms-grid;
    display: grid;
    grid-template-columns: minmax(0, 26px) 1fr;
    -ms-grid-columns: 26px 1fr;/* IE11 */
    padding-bottom: 12px;
}
.boxinbox>span{
    grid-column: 1;
    grid-row-start: 1; 
    grid-row-end: 20; 
    -ms-grid-column: 1;
    grid-row: 1;
    -ms-grid-row: 1;
    -ms-grid-row-span: 20;
    display: block;
    max-width: 16px;
    height: 100%;
    margin-right: 4px;
    padding-right: 4px;
    font-size: 12px;
    line-height: 13px;
    -webkit-writing-mode: vertical-rl;
      -ms-writing-mode: tb-rl;
          writing-mode: vertical-rl;
    border-right: 1px solid #ccc;
}
.boxinbox>div{
    grid-column: 2;
    -ms-grid-column: 2;
    display: flex;
    flex-direction: column;
}
.boxinbox>div hr{
    display: block;
    border:none;
    background-color:rgba(0, 0, 0, 0)
}


/* ルートごとの色彩変更 */
#app.root_trad{
  background: linear-gradient(180deg, $trad_color_main  0%, $trad_color_main  220px, $trad_color_main_light 220px, $trad_graduation_color_1 100%);
}
#app.root_trad header{
  background-color: $trad_color_main;
}
#app.root_trad header .logo_wrapper .house_icon{
  background-position-x: calc(845 / (1725 - 128) * 100%);
  background-position-y: -55px;
}
#app.root_trad header .logo_wrapper .main_logo .version{
  background-color: $trad_accent_color_main;
}
#app.root_trad header .title_command input[type="button"]{
  background-color: $trad_accent_color_sub;
}
#app.root_trad header .right_grid .keisan{
  background-color: $trad_accent_color_main;
}
#app.root_ees{
  background: linear-gradient(180deg, $ees_color_main  0%, $ees_color_main  220px, $ees_color_main_light 220px, $ees_graduation_color_1 100%);
}
#app.root_ees header{
  background-color: $ees_color_main;
}
#app.root_ees header .logo_wrapper .house_icon{
  background-position-x: calc(985  / (1725 - 128) * 100%);
  background-position-y: -55px;
}
#app.root_ees header .logo_wrapper .main_logo .version{
  background-color: $ees_accent_color_main;
}
#app.root_ees header .title_command input[type="button"]{
  background-color: $ees_accent_color_sub;
}
#app.root_ees header .right_grid .keisan{
  background-color: $ees_accent_color_main;
}

/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
  #app{
    width: 100%;
    min-width: 350px;
    padding-top: 100px;
    overflow-x: hidden;
    .wrapper{
      display: block;
      width: calc(100% - 16px);
      min-width: 300px;
      box-sizing: border-box;
      margin: 0 10px 250px;
      padding: 20px 8px 250px 8px;
      background-color: white;
      border-radius: 7px;
      overflow-x: hidden;
      z-index: 10;
      .section_wrap:first-child{
        margin-top: 40px;
      }
    }
    &.menu_opened{
      .wrapper{
        .section_wrap{
          display: block;
        }
      }

    }
  }
}

/* レスポンシブ（1500pxよりウインドウ幅が広いもの） */
@media screen and (min-width: 1000px) {
  .wrapper{
    width: 1000px;
    margin: 16px auto 350px auto;
  }
}


/* 印刷用cssのスタイル */
@media print{
  body {
    background:none;	/*ページ全体の背景色*/
    background-color: white;
    color: black;
  }
  div#app {
    width:100%;		/*幅の指定*/
    padding-top: 0;
    background:none;	/*ページ全体の背景色*/
    background-color: white;
    color: black !important;
  }
  div#app p,
  div#app span{
    color: black !important;
  }
  div#app header{
    height:  80px;
    position: relative;
    background-color: white;
    border-top: 2px black solid;
    border-bottom: 2px black solid;
  }
  div#app .house_icon{
    background-color: #aaa;
    text-shadow: none;
    filter: grayscale(100%);
  }
  div#app .main_logo>span{
    color: black;
    text-shadow: none;
    filter: none;
  }
  div#app .main_logo>.version{
    background-color: transparent;
    border: 2px solid black;
    color: black;
  }
  div#app .main_logo>.root{
    border-color: currentColor;
  }
  div#app .lower_grid,
  div#app .right_grid,
  div#app .nav_box,
  div#app .white_box {
    display: none;
  }
  div#app .section_wrap:first-child {
    margin-top: 0;
  }
  div#app section.app_section{
    width: 100%;
    min-width: 600px;
    border: 1px solid #777;
  }
  div#app .section_wrap>h3 .number{
    filter: grayscale(100%);
  }
  div#app .section_wrap:nth-child(3),
  div#app .section_wrap:nth-child(5),
  div#app .section_wrap:nth-child(9),
  div#app .section_wrap:nth-child(11),
  div#app .section_wrap:nth-child(12){
    page-break-before: always;
  }
  div#app .information{
    background-color: #f2f2f2;
  }
  div#app .help_button {
    opacity: 0;
  }
  div#app label.checked:before {
    color: #999;
  }
  div#app label:after {
    border: 1px solid #555;
  }
  div#app .information .title::before{
    background-color: #777;
    border: 1px solid #555;
  }
  div#app .information a.target_blank{
    color: black;
  }
  div#app .information a.target_blank:after{
    filter: grayscale(100%);
  }
  div#app .link_button{
    display: none;
    opacity: 0;
  }
  div#app .radio_sub_box{
    background-color: #f5f5f5;
  }
  div#app .grid_2 label{
    color: black;
  }
  div#app .flex_center.column{
    display: none;
  }
}
</style>
